var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showChart && _vm.$route.query.tab == 'salaryInformation')?_c('EChart',{attrs:{"chartId":'turnover',"optionChart":_vm.optionChartSalaryData,"heightChart":'580'}}):_vm._e(),(_vm.noneData)?_c('div',{staticClass:"no-data"},[_c('h3',[_vm._v("Không có dữ liệu")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }